const branchData = [
    {
        id: 1,
        name: 'Banjarmasin',
        label: 'Main Branch — South Kalimantan',
        address: 'Jl. Ahmad Yani KM 12.8 Gambut, Banjarmasin 70652, South Kalimantan, Indonesia',
        phone: '0511 – 674 2881',
        fax: '0511 – 674 2882',
        whatsapp: '+62 811 519 0088 / +62 812 5137 3388',
        email: 'kjd_bjm@yahoo.com',
        mapSrc:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4916.2820156079315!2d114.65909417583904!3d-3.3963190965782855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2de427703ddd9487%3A0x57157c3cb1dfd19f!2sKalimantan%20Jaya%20Diesel%20CV%20Banjarmasin!5e1!3m2!1sen!2stw!4v1772874277003!5m2!1sen!2stw',
        link: 'https://maps.app.goo.gl/6Lhp3zzh7pryxAzW7',
    },
    {
        id: 2,
        name: 'Samarinda',
        label: 'Branch — East Kalimantan',
        address: 'Jl. Ir. Sutami Blok L No.8B Karang Asam Ulu, Sungai Kunjang, Samarinda 75126, East Kalimantan, Indonesia',
        phone: '0541 – 277 1779',
        fax: null,
        whatsapp: '+62 821 9944 8336',
        email: 'kjd.samarinda@gmail.com',
        mapSrc:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4924.728680453207!2d117.1051539846511!3d-0.5206153981187784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2df67f8c9cd042bb%3A0xbf3ba5e671fdd1fd!2sCV%20Kalimantan%20Jaya%20Diesel%20Samarinda!5e1!3m2!1sen!2stw!4v1772875205725!5m2!1sen!2stw',
        link: 'https://maps.app.goo.gl/hqeeT1hYLrzqXCp17',
    },
    {
        id: 3,
        name: 'Kendari',
        label: 'Branch — Southeast Sulawesi',
        address: 'Jl. Poros Bandara Haluoleo No.88A Bonggoeyo, Wua-Wua, Kendari 93561, Southeast Sulawesi, Indonesia',
        phone: '+62 813 8707 2701',
        fax: null,
        whatsapp: '+62 813 8707 2701',
        email: 'kjdkendari@gmail.com',
        mapSrc:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4912.919737517018!2d122.50646407584152!3d-4.002561695971161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d988d4654de0ea5%3A0x412e6ab2bfb4cafb!2sKalimantan%20Jaya%20Diesel%20Kendari!5e1!3m2!1sen!2stw!4v1772875237818!5m2!1sen!2stw',
        link: 'https://maps.app.goo.gl/vjyZKycNLhS7LUJK6',
    },
    {
        id: 4,
        name: 'Muara Enim',
        label: 'Branch — South Sumatera',
        address: 'Jl. Jendral Sudirman No.145 Tungkal, Muara Enim 31313, South Sumatera, Indonesia',
        phone: '+62 813 8739 2649',
        fax: null,
        whatsapp: '+62 813 8739 2649',
        email: 'kjdmuaraenim@gmail.com',
        mapSrc:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4914.879685936684!2d103.7680603218358!3d-3.66137489779786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e39f7b1490d0a7b%3A0xacacff4b9d48b348!2sJl.%20Jenderal%20Sudirman%20No.145%2C%20Tungkal%2C%20Kec.%20Muara%20Enim%2C%20Kabupaten%20Muara%20Enim%2C%20Sumatera%20Selatan%2031313%2C%20Indonesia!5e1!3m2!1sen!2stw!4v1772875339454!5m2!1sen!2stw',
        link: 'https://maps.app.goo.gl/TprqAxxMCXB4qCxP9',
    },
    {
        id: 5,
        name: 'Jakarta',
        label: 'Branch — DKI Jakarta',
        address: 'Jl. Krekot Jaya Molek Blok B2 No.1 Jakarta Pusat 11710, DKI Jakarta, Indonesia',
        phone: '+62 811 519 0088',
        fax: null,
        whatsapp: '+62 811 519 0088',
        email: 'kjdjakarta@gmail.com',
        mapSrc:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1455.736094790186!2d106.8287238047237!3d-6.160321515904234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f5dcbc565969%3A0x3a30642f9e42cbc!2sJl.%20Krekot%20Jaya%20Molek%20Ad%20No.1%2C%20RT.4%2FRW.7%2C%20Ps.%20Baru%2C%20Kecamatan%20Sawah%20Besar%2C%20Kota%20Jakarta%20Pusat%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2010710%2C%20Indonesia!5e1!3m2!1sen!2stw!4v1772875470835!5m2!1sen!2stw',
        link: 'https://maps.app.goo.gl/xpYKwyaoXUvfVF4C8',
    },
];

export default branchData;
